'use client';

import { c as _c } from "react/compiler-runtime";
import { useShallow } from 'zustand/react/shallow';
import { useDeviceInfoStore, WEBVIEW_TYPE } from '@/stores/DeviceStore';
export const useAdGuards = () => {
  const $ = _c(5);
  const {
    isMounted,
    osType,
    webviewType
  } = useDeviceInfoStore(useShallow(_temp));
  const isWelloApp = webviewType === WEBVIEW_TYPE.WELLO_APP;
  const isExternalWebview = webviewType === WEBVIEW_TYPE.KB_PAY || webviewType === WEBVIEW_TYPE.TOSS;
  let t0;
  if ($[0] !== isExternalWebview || $[1] !== isMounted || $[2] !== isWelloApp || $[3] !== osType) {
    t0 = {
      isMounted,
      isWelloApp,
      isExternalWebview,
      osType
    };
    $[0] = isExternalWebview;
    $[1] = isMounted;
    $[2] = isWelloApp;
    $[3] = osType;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
};
function _temp(state) {
  return {
    isMounted: state.isMounted,
    osType: state.osType,
    webviewType: state.webviewType
  };
}